<div class="add-cost-modal-all">
  <div class="add-cost-modal-header">
    <h5 class="modal-title">
      {{ "financial-information.add_cost_modal.title" | translate }}
    </h5>

    <button type="button" class="btn-close" (click)="cancel()"></button>
  </div>

  <form [formGroup]="form" class="add-cost-modal-body">
    <div>
      <label class="form-label-add-cost-modal">
        {{ "financial-information.add_cost_modal.label_concept" | translate }}
      </label>
      <tui-input
        formControlName="concept"
        [tuiTextfieldLabelOutside]="true"
        class="w-full input-form"
      >
        {{
          "financial-information.add_cost_modal.placeholder_concept" | translate
        }}
      </tui-input>

      <div
        class="error-msg"
        *ngIf="form.get('concept')?.invalid && form.get('concept')?.touched"
      >
        {{
          "financial-information.add_cost_modal.error_concept_required"
            | translate
        }}
      </div>
    </div>

    <div>
      <label class="form-label-add-cost-modal">
        {{
          "financial-information.add_cost_modal.label_price"
            | translate : { currency: currency || "€" }
        }}
      </label>
      <tui-input
        formControlName="price"
        [tuiTextfieldLabelOutside]="true"
        class="w-full input-form"
        maxlength="10"
      >
        {{
          "financial-information.add_cost_modal.placeholder_price"
            | translate : { currency: currency || "€" }
        }}
      </tui-input>

      <div
        class="error-msg"
        *ngIf="form.get('price')?.invalid && form.get('price')?.touched"
      >
        {{
          "financial-information.add_cost_modal.error_price_invalid" | translate
        }}
      </div>
    </div>
  </form>

  <div class="add-cost-modal-footer">
    <button type="button" class="btn-cancel" (click)="cancel()">
      {{ "financial-information.add_cost_modal.button_cancel" | translate }}
    </button>

    <button
      type="submit"
      class="btn-save"
      [disabled]="saving"
      (click)="confirm()"
    >
      <ng-container *ngIf="!saving; else loaderTpl">
        {{ "financial-information.add_cost_modal.button_add" | translate }}
      </ng-container>
    </button>

    <ng-template #loaderTpl>
      <tui-loader size="s"></tui-loader>
    </ng-template>
  </div>
</div>
